import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';
import { map } from 'rxjs/operators';
import constants from 'src/app/shared/constants';
import { MEMBER } from '../models/member';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(
    private afs: AngularFirestore,
  ) { }

  getByDocId = (docId: string) => {
    return this.afs
      .collection(constants.FB_MEMBERS)
      .doc(docId)
      .snapshotChanges();
  }
  getByProperty = async (property: string,value:string) => {
    const snapshot = await firebase.firestore()
      .collection(constants.FB_MEMBERS).
      where(property,'==',value)
      .get();
      let member=null
      if(!snapshot.empty){
        snapshot.forEach(sn=>{
          member=sn.data()
          member.docId=sn.id
        })
      }
      return member

  }
  getTotalByDocId = () => {
		return firebase.firestore()
		  //.collection(constants.FB_COUNTERS)
		  .collection(constants.FB_MEMBERS)
		  .get();
	}


  async getTotalMembers() {
		const snapshot = await this.getTotalByDocId();
		if (!snapshot.empty) {
			 let total = [];
       snapshot.forEach (sn => {total.push(sn.data())})
       console.log(total.length)

			return total.length;
		}
    else{
      console.log(snapshot)
    }
		return null
	}

  getMembers() {
    return this.afs.collection(constants.FB_MEMBERS, (ref: any) => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      query = query.orderBy('nameToSearch', 'asc');
      return query;
    }).snapshotChanges().pipe(
      map((actions: any) => {
        return actions.map((a: any) => {
          const member = a.payload.doc.data() as MEMBER;
          member.docId = a.payload.doc.id;
          return member;
        });
      })
    );
  }


  doSave = async (docId: string, changes: any) => {
    const collection = this.afs.collection(constants.FB_MEMBERS);

    if (docId === 'new') {
      const res = await collection.add(Object.assign({}, changes));
      docId = res.id;
    } else {

           changes.lastUpdated = firebase.firestore.FieldValue.serverTimestamp();
      await collection.doc(docId).update(Object.assign({}, changes));
    }

    await collection.doc(docId)
      .collection('history')
      .add(Object.assign({}, changes));

    return docId;
  }



}
